import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';
import { PromoActionUser, PromoActionUserDetails } from '@/models/promo-actions.models';

export const promoActionsService = {
  getUserPromoActions,
  getPromoActionDetails,
  changeUserPromoActionStatus
};

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  },
  controller: 'promo-action-user'
};

async function getUserPromoActions(): Promise<Array<PromoActionUser>> {
  let { data } = await axios.get<Array<PromoActionUser>>(`${model.baseUrl}${model.controller}`);
  return (data || []).map(d => new PromoActionUser(d));
}

async function getPromoActionDetails(promoActionUid: string): Promise<PromoActionUserDetails> {
  let { data } = await axios.get<PromoActionUserDetails>(`${model.baseUrl}${model.controller}/${promoActionUid}`);
  return new PromoActionUserDetails(data);
}

async function changeUserPromoActionStatus(promoActionUid: string, status: number) {
  return axios.post(`${model.baseUrl}${model.controller}/${promoActionUid}/status`, { status });
}
